import {useEffect, useState} from 'react';
import styles from './AnnotationsTab.module.scss';

export interface AnnotationsTabProps {
  onChangeText: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  annotations?: string;
  annotationsEnabled?: boolean;
}

function AnnotationsTab({
  onChangeText,
  annotations,
  annotationsEnabled,
}: AnnotationsTabProps): JSX.Element {
  const [hasClickedAnnotationsEnabler, setHasClickedAnnotationsEnabler] =
    useState(false);

  useEffect(() => {
    if (annotationsEnabled) {
      setHasClickedAnnotationsEnabler(true);
    }
  }, [annotationsEnabled]);

  return (
    <>
      <header className={styles.annotationsTabHeader}>
        <h2>Suas anotações:</h2>
        <p>Aqui você vai encontrar todas suas anotações.</p>
      </header>

      {annotations || hasClickedAnnotationsEnabler ? (
        <article className={styles.annnotationsCard}>
          <label htmlFor="annotations">Escreva as suas anotações aqui:</label>
          <textarea
            className={styles.annotations}
            name="annotations"
            defaultValue={annotations}
            placeholder="Digite aqui..."
            onChange={onChangeText}
          />
          <span className={styles.annotationsSaveDescription}>
            As anotações são salvas automaticamente
          </span>
        </article>
      ) : (
        <li>
          <span className={styles.emptyListCard}>
            <p>
              Sem anotações <span className={styles.emoji}>🫠</span>
            </p>

            <p>
              Para criar uma marcação, selecione o botão ”Adicionar anotação”
              acima do texto motivador.
            </p>
          </span>
        </li>
      )}
    </>
  );
}

export default AnnotationsTab;
